import { createFileRoute, Outlet } from "@tanstack/react-router";

import { FlightFiltersProvider } from "@/app/lib/context/FlightFiltersContext";
import { FlightSelectionPayloadProvider } from "@/app/lib/context/FlightSelectionPayloadContext/FlightSelectionPayloadContextProvider";
import { SearchDataMissingErrorBoundary } from "@/app/lib/errors/SearchDataMissingErrorBoundary";
import { useFlightSearchTokens } from "@/app/lib/hooks/useFlightSearchTokens";
import { PurchaseStateContextProvider } from "@/contexts/PurchaseStateContext";

export const Route = createFileRoute("/_authenticated/_flights")({
  component: FlightsRoute,
});

function FlightsRoute() {
  return (
    <SearchDataMissingErrorBoundary>
      <RouteComponent />
    </SearchDataMissingErrorBoundary>
  );
}

function RouteComponent() {
  const { query } = useFlightSearchTokens();

  return (
    <FlightFiltersProvider defaultFilters={query.data?.defaultFilters || null}>
      <FlightSelectionPayloadProvider>
        <PurchaseStateContextProvider>
          <Outlet />
        </PurchaseStateContextProvider>
      </FlightSelectionPayloadProvider>
    </FlightFiltersProvider>
  );
}
